import { inject, Injectable } from '@angular/core';
import { AuthModalStore } from './auth-modal.store';
import { finalize } from 'rxjs';
import { SessionFacade } from '../../core/auth/facades/session.facade';

@Injectable()
export class AuthModalFacade {
  readonly #sessionFacade = inject(SessionFacade);
  readonly #authModalStore = inject(AuthModalStore);

  login(username: string) {
    this.#authModalStore.updateIsLoading(true);

    return this.#sessionFacade
      .login({
        username
      })
      .pipe(finalize(() => this.#authModalStore.updateIsLoading(false)));
  }
}
